import React, { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${BACKEND_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Request failed");

      setStatus("✅ Reset email sent. Check your inbox!");
    } catch (err) {
      setStatus(`❌ ${err.message}`);
    }
  };

  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "auto" }}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          style={{ padding: "12px", width: "100%", marginBottom: "16px", borderRadius: "6px" }}
        />
        <button type="submit" style={{ padding: "10px 20px", borderRadius: "6px", backgroundColor: "#1570EF", color: "white", fontWeight: "bold" }}>
          Send Reset Link
        </button>
        {status && <p style={{ marginTop: "15px" }}>{status}</p>}
      </form>
    </div>
  );
};

export default ForgotPassword;
